module.exports = __webpack_public_path__ + "static/changing-the-face-of-science-small-thumbnails-rect-250x125-86af7622f5b9bda01a0d6f891ca4fe55.jpg";